<template>
  <div class="mask-box" v-if="show" @click="closeConfirm">
    <div class="mask-content">
      <div class="confirm-header">{{ title || "温馨提示" }}</div>
      <div class="confirm-bd">
        <div v-for="(item, index) in content" :key="index">
          {{ item }}
        </div>
      </div>
      <div class="confirm-footer">
        <div class="confirm-ok" @click="closeConfirm">我知道了</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Array,
      default: []
    }
  },
  watch: {
    visible(val) {
      this.show = val;
    }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    closeConfirm() {
      this.$emit("hideConfirm");
    }
  }
};
</script>
<style lang="scss" scoped>
.mask-box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 45px;
  z-index: 9;
}

.mask-content {
  background: white;
  width: 330px;
  box-sizing: border-box;
  border-radius: 8px;
  padding-top: 15px;
}
.confirm-header {
  margin-top: 5px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}
.confirm-bd {
  font-size: 16px;
  color: #999999;
  margin: 20px 30px 0;
  line-height: 24px;
}
.confirm-ok {
  text-align: center;
  flex: 1;
  color: #1890ff;
  font-size: 16px;
}
.confirm-footer {
  min-height: 50px;
  display: flex;
  align-items: center;
  border-top: 1px solid #eeeeee;
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tipDialog.vue